import { useCallback, useEffect, useState } from "react";
import { ModelMode, MODEL_CONFIG, MODEL_MODE_STORAGE_KEY, resolveModelMode } from "../config/modelConfig";

export function useSettings() {
  const [modelMode, setModelModeState] = useState<ModelMode>(() => {
    const stored = localStorage.getItem(MODEL_MODE_STORAGE_KEY) as ModelMode | null;
    return stored === "pro" || stored === "normal" ? stored : "normal";
  });
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [fallbackNotice, setFallbackNotice] = useState<string | null>(null);

  useEffect(() => {
    localStorage.setItem(MODEL_MODE_STORAGE_KEY, modelMode);
  }, [modelMode]);

  const setModelMode = useCallback((mode: ModelMode) => {
    setModelModeState(mode);
    const { effective, notice } = resolveModelMode(mode);
    if (effective !== mode) {
      setModelModeState(effective);
    }
    setFallbackNotice(notice);
  }, []);

  const applyBackendNotice = useCallback((notice: string | null | undefined) => {
    if (notice) setFallbackNotice(notice);
  }, []);

  return {
    modelMode,
    setModelMode,
    settingsOpen,
    setSettingsOpen,
    fallbackNotice,
    setFallbackNotice,
    applyBackendNotice,
    modelConfig: MODEL_CONFIG,
  };
}
